import { useContext } from 'react';
import { AccountContext } from '../components/AccountContext';

export const useAccount = () => useContext(AccountContext)?.account;
